import styles from './Icon.module.css'

export default function Icon ({ children, ...rest }) {
    return <i className={`material-icons ${styles.i}`} {...rest}>{ children }</i>
}